// ============================================================================
// postesBureau.js : les postes du Bureau (Art. 31), source canonique.
// Module sans dépendance : effetsStatutaires.js y lit le libellé d'un poste
// par son identifiant, jamais dans l'effet d'un scrutin (écrit dans sessions/,
// ouvert en écriture ; relecture 3, M4, 30/09/2026). Réexporté par appShared.
// ============================================================================
export const POSTES_BUREAU = [
  { id:"president",     label:"President",                         ordre:1 },
  { id:"vp1",           label:"Premier Vice-president",            ordre:2 },
  { id:"vp2",           label:"Deuxieme Vice-president",           ordre:3 },
  { id:"vp3",           label:"Troisieme Vice-president",          ordre:4 },
  { id:"vp4",           label:"Quatrieme Vice-president (Fonctions publiques)", ordre:5 },
  { id:"vp5",           label:"Cinquieme Vice-president (IARD)",   ordre:6 },
  { id:"sg",            label:"Secretaire general",                ordre:7 },
  { id:"tg",            label:"Tresorier general",                 ordre:8 },
];
